import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, useIntl } from 'react-intl';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import { Container } from '@plone/components';
import config from '@plone/volto/registry';
import cx from 'classnames';
import { listSponsors } from '../../../actions';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import { DetachedTextBlockEditor } from '@plone/volto-slate/blocks/Text/DetachedTextBlockEditor';

const messages = defineMessages({
  defaultSponsorText: {
    id: 'defaultSponsor',
    defaultMessage:
      'Diese Maßnahme wird mitfinanziert durch Steuermittel auf der Grundlage des vom Sächsischen Landtag beschlossenen Haushaltes',
  },
  addSponsorText: {
    id: 'addSponsorText',
    defaultMessage: 'Bitte geben Sie einen Sponsor Text ein',
  },
  alttextWithLink: {
    id: 'alttextWithLink',
    description: 'Alternative text extension for an image with link',
    defaultMessage: ' - link to {href}',
  },
});

const SponsorView = (props) => {
  const { content, metadata, grouptitle, data, editable, className } = props;
  const intl = useIntl();
  // const sponsortext = data?.text;
  data.placeholder = intl.formatMessage(messages.addSponsorText);
  const contentObject = metadata || content || {};
  const sponsors = useSelector((store) => store.sponsors.sponsors);
  const Image = config.getComponent({ name: 'Image' }).component;
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(listSponsors());
  }, [dispatch]);

  return (
    <div className={cx('block sponsor', className)}>
      <Container className="details-container-sponsors">
        <div className="content-container">
          <div className="Sponsor-details">
            <div className="sponsor-text">
              {editable ? (
                <DetachedTextBlockEditor {...props} />
              ) : (
                <TextBlockView {...props} />
              )}
            </div>
            {/* <div className="sponsor-text">
              {sponsortext
                ? sponsortext
                : intl.formatMessage(messages.defaultSponsorText)}
            </div> */}
            <div className="sponsor-detail">
              {data?.items?.map((sponsorID, index) => {
                const sponsor = sponsors?.sponsors?.find(
                  (s) => s.id === sponsorID,
                );
                const ate = intl.formatMessage(messages.addSponsorText, {
                  href: sponsor?.url ? sponsor.url : '',
                });

                return (
                  sponsor && (
                    <div className="sponsor-logo" key={index}>
                      <ConditionalLink
                        href={sponsor.url}
                        condition={sponsor.url && !editable}
                      >
                        <Image
                          item={sponsor}
                          imageField="logo"
                          alt={
                            sponsor.url
                              ? `Logo ${sponsor.title}${ate}`
                              : `Logo ${sponsor.title}`
                          }
                        />
                      </ConditionalLink>
                    </div>
                  )
                );
              })}
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default SponsorView;
